import SuperFetch from "../utils/superFetch";

export const apiTemplate = async () => {
    try {
        

    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const getOtpForMobile = async(mobileNumber) => {
    try {
        let data = {
            mobileNumber
        }
        let response = await SuperFetch('/api/send/otp/mobile', 'post', data)
        return response
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const getOtpForEmail = async(email) => {
    try {
        let data = {
            email
        }
        let response = await SuperFetch('/api/send/otp/email', 'post', data)
        return response
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const verifyNewUserForMobile = async (mobileNumber, otp) => {
    try {
        let data = {
            otp,
            mobileNumber
        }
        let response = await SuperFetch("/api/send/otp/verify", "post", data)
        return response
       
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const verifyNewUserForEmail = async (email, otp) => {
    try {
        let data = {
            otp,
            email
        }
        let response = await SuperFetch("/api/send/otp/verify", "post", data)
        return response
       
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const verifyOtpForMobile = async (mobileNumber, otp) => {
    try {
        let data = {
            otp,
            mobileNumber
        }
        let response = await SuperFetch("/api/send/verify/mobile", "post", data)
        return response
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const verifyOtpForEmail = async (email, otp) => {
    try {
        let data = {
            otp,
            email
        }
        let response = await SuperFetch("/api/send/verify/email", "post", data)
        return response
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const registerNewUser = async (data) => {
    try {
        let response = await SuperFetch("/api/send/register", "post", data)
        return response
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}

export const getMemberProfile = async (token) => {
    try {
        let response = await SuperFetch('/api/send/profile', 'get', {}, token)
        return response;
    } catch (err) {
        return {
            status: false ,
            statusCode: err.response ? err.response.code : '', 
            err : {
                msg : err.message
            }
        }
    }
}